import { gql, type OperationVariables } from '@apollo/client';
import { EEntityType } from '@sharedInterfaces/globalEnums';
import type { IDashboardDTO } from '@sharedInterfaces/IDashboard';
import Dashboard, { dashboardGQL } from '@src/Objects/Dashboard';
import { deleteDashboard, updateDashboard } from '@store/reducer/dashboardReducer';
import store from '@store/store';

import GraphQL from '../graphQL';
import { NotFoundError } from '../NotFoundError';

const q = gql`
query GetDashboard($dashboardId: ID!) {
    dashboard(id:  $dashboardId) 
    ${dashboardGQL}
},
`;

/**
 * Retrieves a dashboard by dashboardId.
 *
 * @param {string} dashboardId - The ID of the dashboard to retrieve.
 * @returns {Promise<{ dashboard: IDashboard }>} A promise that resolves with the retrieved dashboard.
 */
export default function getDashboard(dashboardId: string) {
    const variables: OperationVariables = { dashboardId };
    return GraphQL.query<{ dashboard: IDashboardDTO }>(q, variables).then((obj) => {
        if (!obj?.dashboard) {
            store.dispatch(deleteDashboard(dashboardId));
            throw new NotFoundError(dashboardId, EEntityType.DASHBOARD);
        }
        const newDashboard = new Dashboard(obj.dashboard);
        store.dispatch(updateDashboard(newDashboard));
        return newDashboard;
    });
}
